import { useEffect, useMemo } from 'react';
import styles from './Style.module.css'
import BrandIcon from '../../Assets/Images/brand_icon_new.svg'
import { OptionCard } from '../../Components/OptionCard/OptionCard'
import { Logo } from '../../Components/Logo/Logo';
import { useCartContext } from '../../Context/Cart/CartContext';
import { useWebSettings } from '../../Context/WebSettings/WebSettingsContext';
import LoaderMain from '../../Components/Loader/LoaderMain';
import { useNavigate } from 'react-router-dom';
import { setSessionStorageValue } from "../../Utils/SessionStorage.js";
import { BtnPrimary } from '../../Components/Buttons/BtnPrimary.js';
import { useCustomer } from '../../Context/Customer/CustomerContext.js';



export const Home = () => {
  const {
    setAppointmentTypeID,
    appointmentTypeID,
    setIsLoadingMainActive,
    isLoadingMainActive,
    setOutletTypeID,
  } = useCartContext();

  const {
    headerLogoUrl,
    backgroundImageUrl,
    title,
    subTitle,
  } = useWebSettings();

  const navigate = useNavigate();
  const { setIsUserVerified, setVerifiedMobile } = useCustomer();

  // const appointmentParams = useMemo(() => ({
  //   pagination: 0,
  //   status: 1,
  // }), []);
  // Static mock data
const APPOINTMENT_TYPE_LIST = [
  {
    id: 1,
    name: "Booking for 1 pax",
    description: "Booking services for 1 pax"
  },
  {
    id: 2,
    name: "Booking for 2-4 pax",
    description: "For yourself and others"
  }
];
  // const { data: appointmentData, isLoading } = useGetAppointmentType(appointmentParams);
  // const appointmentTypeList = appointmentData?.data?.data?.list?.booking_type || [];

const appointmentTypeClick = (key, value) => {
    setIsUserVerified(false);
    setVerifiedMobile("");
    setAppointmentTypeID(value);
    setSessionStorageValue("appointment_type", value);
    navigate('/outlets');
  };


  const goToSelectVouchers = () => {
    navigate('/select-vouchers');
  };
  
  useEffect(() => {
    setIsLoadingMainActive(false);
  }, [setIsLoadingMainActive]);

  return (
    <>
    {isLoadingMainActive && <LoaderMain /> }
    <div
      className={`${styles.home} space-x`}
      style={{ "--home-bg-image": `url("${backgroundImageUrl}")` }}
    >
      <div className={styles.homeBackground} aria-hidden="true" />

      <div className={`${styles.contentOuter}`}>
        <div className={styles.content}>
          <Logo
          customClass={styles.logo}
          src={headerLogoUrl}
          />
          <div className={styles.contentText}>
            <h1>{title}</h1>
            <h2>{subTitle}</h2>
          </div>

          <div className={styles.space}></div>

          <div className={styles.card}>
            <img src={BrandIcon} className={styles.icon} alt='' />
            <div className={styles.cardInner}>
              <h2>Select an option</h2>
              <div className={styles.optionCards}>
                {/* {isLoading ? (
                    <Loader/>
                  ) : <div> */}
                        {APPOINTMENT_TYPE_LIST.length > 0 ? (
                        APPOINTMENT_TYPE_LIST.map((item, index) => (
                          <OptionCard key={index}
                          title={item?.name}
                          text={item?.description}
                          handleClick={() => appointmentTypeClick('appoinment', item.id)}
                          selected={item.id===appointmentTypeID ? "selected" : ""}
                          />
                        ))
                      )
                      :<h5>Appointment type not found</h5>
                      }
                  {/* </div> */}
                {/* } */}
              </div>
              <div className={`${styles.cardBottom} ${styles.contactOutletBtnContainer}`}>
               <a
                className="underline btn"
                href="https://www.natureland.com.sg/locations/"
                target="_blank"
                rel="noopener noreferrer"
              >
                For large groups, contact the outlet
              </a>
              </div>
              {window.location.hostname === 'localhost' && (
                <div className={`${styles.cardBottom} ${styles.giftVouchersBtnContainer}`}>
                  <BtnPrimary
                    label="Purchase Gift Vouchers"
                    customClass={styles.giftVouchersBtn}
                    noIcon={true}
                    handleClick={goToSelectVouchers}
                  />
                </div>
              )}
            </div>
          </div>

        </div>
      </div>
      
    </div>
    </>
  )
};
